import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider } from "./components/utils/AuthContext"; // <- HIER

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <I18nProvider>
            <AuthProvider>
                <App />
            </AuthProvider>
        </I18nProvider>
    </React.StrictMode>
);

reportWebVitals();